<div class="modal-body text-black d-flex flex-column gap-2">
  <h2>Deleting <strong>{{firmwareId}}</strong></h2>
  <div *ngIf="deleteStats; else noStats">
    @if (!deleting) {
      <p>
        Please review the information regarding the firmware you want to delete :
      </p>
      <table class="table table-borderless text-body table-sm">
        <tr>
          <th class="text-end"><strong>{{deleteStats.metaversions.length}}</strong></th>
          <td>
            metaversions include this firmware
            <ul class="list-unstyled mb-0">
              <li *ngFor="let metaversion of deleteStats.metaversions">
                <a routerLink="/metaversions/{{ metaversion.id }}" target="_blank">{{metaversion.id}}</a>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <th class="text-end"><strong>{{deleteStats.enabledMetaversionsCount}}</strong></th>
          <td>metaversions <strong>enabled</strong></td>
        </tr>
        <tr>
          <th class="text-end"><strong>{{deleteStats.jobs.length}}</strong></th>
          <td>deployments <strong>ongoing</strong></td>
        </tr>
        <tr>
          <th class="text-end"><strong>{{deleteStats.affectedThingsCount}}</strong></th>
          <td>things with this version</td>
        </tr>
      </table>
    } @else {
      <div class="d-flex flex-column gap-0" *ngFor="let action of actions" >
        <div class="d-flex justify-content-between align-items-center">
          <span [ngSwitch]="action.step" class="d-flex gap-1">
            <ng-container *ngSwitchCase="'DEACTIVATE_METAVERSION'">
              <strong>Deactivating Metaversions</strong>
            </ng-container>
            <ng-container *ngSwitchCase="'CANCEL_DEPLOYMENT'">
              <strong>Cancelling deployments</strong>
            </ng-container>
            <ng-container *ngSwitchCase="'DELETE_FIRMWARE'">
              <strong>Deleting binaries (signed & unsigned)</strong>
            </ng-container>
          </span>
          <span [ngClass]="{
            'text-warning': action.state === 'pending',
            'text-primary': action.state === 'working',
            'text-success': action.state === 'done',
            'text-danger': action.state === 'failed'
          }">
            <i [class]="icons[action.state]" [ngClass]="{
              'fa-spin': action.state === 'working',
            }"></i>
          </span>
        </div>
        <div class="text-danger" *ngIf="action.error">
          {{ action.error }}
        </div>
        <div class="d-flex flex-column gap-0 ps-4" *ngIf="action.subSteps">
          <div class="d-flex flex-column" *ngFor="let subStep of action.subSteps">
            <div class="d-flex justify-content-between align-items-center">
              {{ subStep.id }}
              <span class="dotted-spacer flex-grow-1 mx-3"></span>
              <span [ngClass]="{
                'text-warning': subStep.state === 'pending',
                'text-primary': subStep.state === 'working',
                'text-success': subStep.state === 'done',
                'text-danger': subStep.state === 'failed'
              }" *ngIf="action.state !== 'pending'">
                <i [class]="icons[subStep.state]" [ngClass]="{
                  'fa-spin': subStep.state === 'working',
                }"></i>
              </span>
            </div>
            <div class="text-danger" *ngIf="subStep.error">
              {{ subStep.error }}
            </div>
          </div>
        </div>
      </div>
    }
    <p class="mt-4">
      The Metaversions will be <strong>disabled</strong> and <strong>deprecated</strong>, the deployments <strong>cancelled</strong>, and the firmware files <strong>permanently deleted</strong>.<br>
    </p>
    <p>
      The deployed firmware <strong>will not be reverted</strong> from devices, and the "nextFirmware" <strong>will not be removed</strong> from the shadow.
    </p>
    <p class="alert alert-warning mt-4">
      <strong>Deleting a firmware is irreversible</strong>.<br>
    </p>
  </div>
  <div class="d-flex mt-2 justify-content-between">
    <div>
      <button class="btn btn-secondary" (click)="cancel()" [hidden]="done">Cancel</button>
    </div>
    @if (deleteStats) {
      <div>
        <button class="btn btn-danger" (click)="confirmDeletion()" *ngIf="!done">Confirm Deletion</button>
        <button class="btn btn-primary" (click)="close()" *ngIf="done">Close</button>
      </div>
    }
  </div>
</div>

<ng-template #noStats>
  @if (loading) {
    <div class="text-center mt-4 text-primary">
      Fetching Statistics ...
    </div>
  } @else {
    <div class="text-center mt-4 text-danger">
      Could not load statistics
    </div>
  }
</ng-template>
